import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { TradingChannelProfileImpl } from "../model/impl/TradingChannelProfileImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class TradingChannelProfileImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: TradingChannelProfileImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.tradingSourceDisplayName != null) {
      this.baseEncoder.writeStartFid(2, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(2),
        false,
        encodable.tradingSourceDisplayName,
        streamout,
      );
      this.baseEncoder.writeEndFid(2, streamout);
    }
    /*Object encoding*/
    if (encodable.isAutoRouteToSI != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(3),
        false,
        encodable.isAutoRouteToSI,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.isSupportsAccountAliasFg != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(4),
        false,
        encodable.isSupportsAccountAliasFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.isQueueBackedChannelFg != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(6),
        false,
        encodable.isQueueBackedChannelFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.modificationsAllowed != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(7),
        false,
        encodable.modificationsAllowed,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.cancellationAllowed != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(8),
        false,
        encodable.cancellationAllowed,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.isMarkupAllowedFg != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(9),
        false,
        encodable.isMarkupAllowedFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.minUsdEquivTradingAmount != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(10),
        false,
        encodable.minUsdEquivTradingAmount,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.isCreditApprovalEnabledFg != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(11),
        false,
        encodable.isCreditApprovalEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.diTimeoutSecs != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(12),
        false,
        encodable.diTimeoutSecs,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.tiTimeoutSecs != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(13),
        false,
        encodable.tiTimeoutSecs,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.isSupportsUserAliasFg != null) {
      this.baseEncoder.writeStartFid(14, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(14),
        false,
        encodable.isSupportsUserAliasFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(14, streamout);
    }
    /*Object encoding*/
    if (encodable.validateBranchGoodUntilFg != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(15),
        false,
        encodable.validateBranchGoodUntilFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.channelId != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(16),
        false,
        encodable.channelId,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.groupTradingChannelId != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(17),
        false,
        encodable.groupTradingChannelId,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.creditApprovalAction != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(18),
        false,
        encodable.creditApprovalAction,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.preNettingEnabledFg != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(19),
        false,
        encodable.preNettingEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        TradingChannelProfileImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [2, "java.lang.String"],
    [3, "java.lang.Boolean"],
    [4, "java.lang.Boolean"],
    [5, "java.lang.String"],
    [6, "java.lang.Boolean"],
    [7, "java.lang.Long"],
    [8, "java.lang.Long"],
    [9, "java.lang.Boolean"],
    [10, "java.math.BigDecimal"],
    [11, "java.lang.Boolean"],
    [12, "java.lang.Long"],
    [13, "java.lang.Long"],
    [14, "java.lang.Boolean"],
    [15, "java.lang.Boolean"],
    [16, "java.lang.String"],
    [17, "java.lang.String"],
    [18, "java.lang.Long"],
    [19, "java.lang.Boolean"],
    [100, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: TradingChannelProfileImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /* reserved: @TypeScriptIgnore — decode only */
          this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          this.baseEncoder.readEndFid(streamin);
          break;
        }

        case 2: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(2),
            streamin,
          );
          encodable.tradingSourceDisplayName = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.isAutoRouteToSI = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.isSupportsAccountAliasFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 5: {
          /* reserved: @TypeScriptIgnore — decode only */
          this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(5),
            streamin,
          );
          this.baseEncoder.readEndFid(streamin);
          break;
        }

        case 6: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.isQueueBackedChannelFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.modificationsAllowed = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.cancellationAllowed = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.isMarkupAllowedFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.minUsdEquivTradingAmount = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.isCreditApprovalEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.diTimeoutSecs = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.tiTimeoutSecs = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 14: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(14),
            streamin,
          );
          encodable.isSupportsUserAliasFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.validateBranchGoodUntilFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.channelId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.groupTradingChannelId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.creditApprovalAction = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.preNettingEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            TradingChannelProfileImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return TradingChannelProfileImplEncoder.fidTypeMap.has(fid);
  }
}
